function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m933.14 119.48c-71.203-71.203-183.1-78.141-267.61-22.594-9.0469 5.9531-10.594 18.609-3.2812 25.969l267.52 267.52c7.3125 7.3125 20.016 5.7656 25.969-3.2812 55.547-84.469 48.609-196.4-22.594-267.61z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m629.68 140.68c-4.0781-4.0781-10.734-4.0781-14.812 0l-1.6875 1.6875c-50.016 50.016-50.016 131.06 0 181.08l116.02 116.02c50.016 50.016 131.06 50.016 181.08 0l1.6875-1.6875c4.0781-4.0781 4.0781-10.734 0-14.812z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m839.86 1033.4h-175.36v-463.26l76.594-62.625c4.3125-3.4688 3.8438-10.359-0.98438-12.984-13.594-7.3125-26.344-16.594-37.875-28.125l-116.02-116.02c-11.438-11.438-20.812-24.281-28.125-37.875-2.625-4.8281-9.5156-5.2969-12.984-0.98438l-326.72 400.03c-15.844 19.359-14.438 47.578 3.2344 65.25l54.094 54.094c17.672 17.672 45.938 19.125 65.25 3.375l241.6-197.26v396.32h-175.5c-25.828 0-46.781 21.047-46.781 46.875v12.984c0 25.828 20.906 46.781 46.781 46.781h432.74c25.828 0 46.875-20.906 46.875-46.781v-12.984c0-25.828-21.047-46.875-46.875-46.875zm-253.78-524.06c-3.4688 16.219-19.453 26.672-35.812 23.203-16.219-3.4688-26.672-19.594-23.203-35.953 3.6094-16.219 19.594-26.578 35.953-23.062 16.219 3.4688 26.672 19.453 23.062 35.812z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneIcon);
export default __webpack_public_path__ + "static/media/microphone_icon.2ccdc0f82faaf8936b5f57a7c0bfc9d6.svg";
export { ForwardRef as ReactComponent };